import { RouteGroup, SingleRoute } from '@Constants/routes';
import api from '@Services/api';
import React from 'react';
import Analytics from '../Analytics';
import EducationTab from '../Pages/EducationTab';
import {
	BundlesStatsTab,
	ClassroomsStatsTab,
	StandaloneCoursesStatsTab,
} from '../Pages/FamilyTabs';
import InstructorDetail from '../Pages/InstructorDetail';
import InstructorsTab from '../Pages/InstructorsTab';
import OverviewTab from '../Pages/OverviewTab';
import UsageTab from '../Pages/UsageTab';

/**
 * Same source serves both portals (the instructor app re-exports this dir):
 * cross-instructor tabs exist only where the API itself is the admin one.
 */
const isAdminPortal = api.defaults.baseURL?.includes('/admin/');

const adminOnlyRoutes: SingleRoute[] = isAdminPortal
	? [
			{
				// Must sit ABOVE 'instructors' in the array — the container maps
				// array order into the <Switch>, and the non-exact 'instructors'
				// route would swallow '/instructors/:id' first.
				title: 'Instructor',
				route: 'instructors/:id',
				code: 'v-anlt',
				component: <InstructorDetail />,
				offMenu: true,
			},
			{
				title: 'Instructors',
				route: 'instructors',
				code: 'v-anlt',
				component: <InstructorsTab />,
			},
			{
				title: 'Education',
				route: 'education',
				code: 'v-anlt',
				component: <EducationTab />,
			},
	  ]
	: [];

export const AnalyticsRoute: RouteGroup = {
	title: 'Analytics',
	route: 'analytics',
	code: 'v-anlt',
	icon: 'monitoring',
	component: <Analytics />,
	isRouted: true,
	isParent: true,
	overviewRoute: 'overview',
	routes: [
		{
			title: 'Overview',
			route: 'overview',
			code: 'v-anlt',
			component: <OverviewTab />,
			// The group's overviewRoute already renders an auto "Overview" nav
			// chip linking to the base URL (which redirects here) — a visible
			// entry would duplicate it.
			offMenu: true,
		},
		{
			title: 'Classrooms',
			route: 'classrooms',
			code: 'v-anlt',
			component: <ClassroomsStatsTab />,
			requiresClassrooms: true,
		},
		{
			// Route names 'standalone-courses' / 'bundles' inherit their platform
			// gating from usePlatformMode.isRouteEnabled's name matching.
			title: 'Standalone Courses',
			route: 'standalone-courses',
			code: 'v-anlt',
			component: <StandaloneCoursesStatsTab />,
		},
		{
			title: 'Bundles',
			route: 'bundles',
			code: 'v-anlt',
			component: <BundlesStatsTab />,
		},
		...adminOnlyRoutes,
		{
			title: 'Usage',
			route: 'usage',
			code: 'v-anlt',
			component: <UsageTab showInstructorControls={isAdminPortal} />,
		},
	],
};
